import React from 'react';

import { ReactComponent as EditButton } from '../../assets/images/editButton.svg';
import './card.css';

const BrancheCard = ({
  title,
  onClick,
  data = [],
  noEditIcon = false,
  ...props
}) => {
  const renderData = () =>
    data.map((el, index) => (
      <div className="brancheCard__card" key={index}>
        {el.map((e, index) => (
          <span key={index}>{e}</span>
        ))}
      </div>
    ));

  return (
    <div className="brancheCard" {...props}>
      <div className="strasseCard__header">
        <p>{title}</p>
        {!noEditIcon && <EditButton onClick={onClick} />}
      </div>
      <div className="brancheCard__content">{renderData()}</div>
    </div>
  );
};

export default BrancheCard;
